import { useState } from 'react';
import './CardHoverInfo.css';

function CardHoverInfo({ card, children }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="card-hover-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {isHovered && (
        <div className="card-hover-info">
          <h4>{card.name}</h4>
          <p className="card-keywords">{card.keywords}</p>
        </div>
      )}
    </div>
  );
}

export default CardHoverInfo;
